export default __webpack_public_path__ + "static/media/of_6.8a1f17ad.mp3";